module.exports = __webpack_public_path__ + "static/media/stars-1920.cadbdec7.webp";